export default __webpack_public_path__ + "static/attest_flow-e4734985f336ffd63a05e5830e802f94.png";